// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bcMoTq {
  padding: var(--spacing-3) 0 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
}

.rf4xBE {
  margin: 0 0 var(--spacing-3);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.d837BS {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 40px;
  align-items: center;
}

@media (max-width: 900px) {
  .d837BS {
    grid-template-columns: 1fr;
    gap: 40px;
    align-items: flex-start;
  }
}

.hJABXy {
  position: relative;
  width: 100%;
  min-width: 0;
  height: 17rem;
  border-radius: var(--card-border-radius);
  overflow: hidden;
  background: linear-gradient(270deg, transparent 0%, var(--text-neutral-soft) 100%);
}

.ehr6hJ {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.GoWoI8 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-width: 0;
  gap: var(--spacing-4);
  box-sizing: border-box;
}

._H3fmr {
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: 38px;
  letter-spacing: 0;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: left;
}

.gVXygy {
  color: var(--brand-tr-orange);
  font-weight: var(--font-weight-medium);
}

.X3aMS6 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-2);
}

.X3aMS6 .oxBXfb {
  width: fit-content;
  max-width: 100%;
  white-space: nowrap;
  justify-content: center;
  padding: var(--spacing-1-5);
  box-sizing: border-box;
  line-height: 1;
  font-weight: var(--font-weight-medium) !important;
}

.FaX0L5 {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--link-default);
  font-family: var(--font-family-base);
  text-decoration: underline;
  text-underline-offset: 0.12em;
}

.FaX0L5:hover {
  color: var(--link-hover);
}

.sCU7Fm,
.x6sn5U {
  flex-shrink: 0;
}

.FaX0L5 .sCU7Fm,
.FaX0L5 .x6sn5U {
  width: 1rem;
  height: 1rem;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesHeroSection/InsideSalesHeroSection.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,0BAA0B;EAC1B,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd","sourcesContent":[".hero {\n  padding: var(--spacing-3) 0 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.brand {\n  margin: 0 0 var(--spacing-3);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 40px;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .grid {\n    grid-template-columns: 1fr;\n    gap: 40px;\n    align-items: flex-start;\n  }\n}\n\n.visual {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  height: 17rem;\n  border-radius: var(--card-border-radius);\n  overflow: hidden;\n  background: linear-gradient(270deg, transparent 0%, var(--text-neutral-soft) 100%);\n}\n\n.heroImg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  min-width: 0;\n  gap: var(--spacing-4);\n  box-sizing: border-box;\n}\n\n.headline {\n  margin: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 38px;\n  letter-spacing: 0;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: left;\n}\n\n.accent {\n  color: var(--brand-tr-orange);\n  font-weight: var(--font-weight-medium);\n}\n\n.ctaStack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n}\n\n.ctaStack .primaryCta {\n  width: fit-content;\n  max-width: 100%;\n  white-space: nowrap;\n  justify-content: center;\n  padding: var(--spacing-1-5);\n  box-sizing: border-box;\n  line-height: 1;\n  font-weight: var(--font-weight-medium) !important;\n}\n\n.specialistLink {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--link-default);\n  font-family: var(--font-family-base);\n  text-decoration: underline;\n  text-underline-offset: 0.12em;\n}\n\n.specialistLink:hover {\n  color: var(--link-hover);\n}\n\n.specialistIcon,\n.externalIcon {\n  flex-shrink: 0;\n}\n\n.specialistLink .specialistIcon,\n.specialistLink .externalIcon {\n  width: 1rem;\n  height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `bcMoTq`,
	"brand": `rf4xBE`,
	"grid": `d837BS`,
	"visual": `hJABXy`,
	"heroImg": `ehr6hJ`,
	"copy": `GoWoI8`,
	"headline": `_H3fmr`,
	"accent": `gVXygy`,
	"ctaStack": `X3aMS6`,
	"primaryCta": `oxBXfb`,
	"specialistLink": `FaX0L5`,
	"specialistIcon": `sCU7Fm`,
	"externalIcon": `x6sn5U`
};
module.exports = ___CSS_LOADER_EXPORT___;
